import { supabase } from './supabase'

/**
 * Audit log helper — registra ações sensíveis em `public.audit_log`.
 * Best-effort: falhas são logadas no console mas não propagam (não quebra a action principal).
 *
 * Ações conhecidas:
 *  - 'company.activate' / 'company.deactivate' (superadmin)
 *  - 'user.invite' / 'user.remove' / 'user.role_change' (admin)
 *  - 'account.delete_request' / 'account.delete_cancel' (LGPD)
 *  - 'erp.connect' / 'erp.disconnect'
 *
 * Convenção: `<entidade>.<ação_no_passado_ou_imperativo>` em snake_case.
 */
export async function logAudit(
  action: string,
  opts: {
    target_type?: string
    target_id?: string
    payload?: Record<string, unknown>
  } = {},
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) return

    // Tenta resolver company_id do profile (se existir).
    const { data: profile } = await supabase
      .from('profiles')
      .select('company_id')
      .eq('id', user.id)
      .maybeSingle()

    await supabase.from('audit_log').insert({
      actor_id: user.id,
      actor_email: user.email,
      company_id: (profile?.company_id as string | undefined) ?? null,
      action,
      target_type: opts.target_type ?? null,
      target_id: opts.target_id ?? null,
      payload: opts.payload ?? null,
      user_agent: navigator.userAgent.slice(0, 500),
    })
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[audit] log failed:', action, e)
  }
}
